import request from "@/utils/request";
// 专题活动详情
export const  activityInfo =(query) =>{
    return request({
        url: "/authservice/eduActivity/activity/info",
        method:"get",
        params: query
    })
}

//提交报名资料
export const  signUpActivity =(data) =>{
    return request({
        url: "/authservice/eduActivity/activity/signUp",
        method:"post",
        data: data
    })
}

// 查询报名资料
export const  infoActivitySignUp =(query) =>{
    return request({
        url: "/authservice/eduActivity/activity/signInfo",
        method:"get",
        params: query
    })
}